import { basicNumberComparator, locationComparator, statusComparator } from "utils/comparatorUtils.js";
import { getYesOrNo } from "utils/utils.js";
import { SYSTEM_TABLE_COLUMNS } from "constants/constantStrings";

import SystemDeleteRenderer from "./SystemDeleteRenderer.jsx";
import SystemEditRenderer from "./SystemEditRenderer.jsx";
import { COUNTRIES_WITH_CODE, SYSTEM_FIELDS } from "./SystemForm.constant.js";

const SYSTEM_TABLE_COL_DEF = filter => [
  {
    field: SYSTEM_FIELDS.SystemID,
    headerName: SYSTEM_TABLE_COLUMNS.sysId,
    defaultSort: "asc",
    editable: false,
    filter: filter
  },
  {
    field: SYSTEM_FIELDS.SystemName,
    headerName: SYSTEM_TABLE_COLUMNS.systemName,
    editable: false,
    filter: filter
  },
  {
    field: SYSTEM_FIELDS.SystemUnits,
    headerName: SYSTEM_TABLE_COLUMNS.systemUnits,
    width: 80,
    editable: false,
    filter: filter
  },
  {
    field: SYSTEM_FIELDS.SystemLocation,
    headerName: SYSTEM_TABLE_COLUMNS.systemLocation,
    editable: false,
    filter: filter,
    valueFormatter: ({ data }) => {
      const value = data?.[SYSTEM_FIELDS.SystemLocation];
      return COUNTRIES_WITH_CODE[value] || value;
    },
    comparator: locationComparator
  },
  {
    field: SYSTEM_FIELDS.Size,
    headerName: SYSTEM_TABLE_COLUMNS.size,
    editable: false,
    width: 100,
    filter: filter,
    comparator: basicNumberComparator
  },
  {
    field: SYSTEM_FIELDS.DesignFlow,
    headerName: SYSTEM_TABLE_COLUMNS.designFlow,
    editable: false,
    width: 150,
    filter: filter
  },
  {
    field: SYSTEM_FIELDS.PreTreatment,
    headerName: SYSTEM_TABLE_COLUMNS.preTreatment,
    valueFormatter: params => getYesOrNo(params.data.PreTreatment),
    editable: false,
    width: 175,
    filter: filter,
    comparator: statusComparator
  },
  {
    field: SYSTEM_FIELDS.PostTreatment,
    headerName: SYSTEM_TABLE_COLUMNS.postTreatment,
    valueFormatter: params => getYesOrNo(params.data.PostTreatment),
    editable: false,
    width: 175,
    filter: filter,
    comparator: statusComparator
  },
  {
    field: SYSTEM_FIELDS.Address,
    headerName: SYSTEM_TABLE_COLUMNS.address,
    editable: false,
    filter: filter
  },
  {
    field: SYSTEM_FIELDS.CIT3Average,
    headerName: SYSTEM_TABLE_COLUMNS.cit3Average,
    editable: false,
    filter: filter
  },
  {
    field: SYSTEM_FIELDS.Max,
    headerName: SYSTEM_TABLE_COLUMNS.max,
    valueFormatter: params => getYesOrNo(params.data.Max),
    editable: false,
    filter: filter,
    comparator: statusComparator
  },
  {
    field: SYSTEM_FIELDS.Enabled,
    headerName: SYSTEM_TABLE_COLUMNS.enabled,
    valueFormatter: params => getYesOrNo(params.data.Enabled),
    editable: false,
    filter: filter,
    comparator: statusComparator
  },
  {
    colId: "edit",
    lockPinned: true,
    pinned: "right",
    editable: false,
    width: 50,
    cellRendererFramework: SystemEditRenderer
  },
  {
    colId: "delete",
    lockPinned: true,
    pinned: "right",
    editable: false,
    width: 50,
    cellRendererFramework: SystemDeleteRenderer
  }
];

export const getSystemsTableColDef = filter => SYSTEM_TABLE_COL_DEF(filter);
